module.exports = __webpack_public_path__ + "static/tff-f2bdc9fb80b3e9ca9201ab1f7f9b5320.jpg";